export enum OnboardingIntroExperimentVariant {
  CONTROL = "control",
  INTRO_SCREEN = "intro_screen",
  NONE = "none",
}
